(function () {
  'use strict';

  function initSchoolayAnimations() {

    const elements = document.querySelectorAll(
      '.schoolay-reveal, .schoolay-reveal-image'
    );

    if (!elements.length) return;

    /*
     * Shopify Theme Editor:
     * Keep everything visible while editing.
     */
    if (
      document.documentElement.classList.contains('shopify-design-mode')
    ) {
      elements.forEach(function (element) {
        element.classList.add('schoolay-is-visible');
      });

      return;
    }

    /*
     * Respect reduced-motion preferences.
     */
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      elements.forEach(function (element) {
        element.classList.add('schoolay-is-visible');
      });

      return;
    }

    /*
     * Scroll reveal.
     */
    const observer = new IntersectionObserver(
      function (entries, observer) {

        entries.forEach(function (entry) {

          if (!entry.isIntersecting) return;

          entry.target.classList.add('schoolay-is-visible');

          observer.unobserve(entry.target);

        });

      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -60px 0px'
      }
    );

    elements.forEach(function (element) {
      observer.observe(element);
    });


    /*
     * Image scale effect.
     */
    const images = document.querySelectorAll(
      '.schoolay-parallax-image'
    );

    function updateParallax() {

      const viewportHeight = window.innerHeight;

      images.forEach(function (image) {

        const rect = image.getBoundingClientRect();

        if (
          rect.bottom < 0 ||
          rect.top > viewportHeight
        ) {
          return;
        }

        const progress =
          (viewportHeight - rect.top) /
          (viewportHeight + rect.height);

        const movement =
          (progress - 0.5) * 35;

        image.style.transform =
          'scale(1.06) translate3d(0,' +
          movement +
          'px,0)';

      });

    }

    let ticking = false;

    window.addEventListener(
      'scroll',
      function () {

        if (!ticking) {

          window.requestAnimationFrame(function () {

            updateParallax();

            ticking = false;

          });

          ticking = true;
        }

      },
      { passive: true }
    );

    updateParallax();
  }


  /*
   * Normal page.
   */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initSchoolayAnimations
    );

  } else {

    initSchoolayAnimations();

  }


  /*
   * Shopify Theme Editor section reload.
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      initSchoolayAnimations();
    }
  );

})();